import React from 'react'
import { useSelector } from 'react-redux'

import { getSystemLng } from 'stores/Account/Select'
import useMediaQuery from 'hooks/useMediaQuery'

import { DatePicker, ConfigProvider, Space } from 'antd';
import _ from 'lodash'

import { useTheme } from 'contexts/ThemeProvider'
import { antdThemeConfig } from 'helpers/antdUtils'

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

import enUS from 'antd/locale/en_US';
import esES from 'antd/locale/es_ES';
import { Icon } from 'semantic-ui-react'

import themeStyles from 'components/DatePicker/styles'

const DateSelector = props => {
  const systemLng = useSelector(getSystemLng)
  const label = _.get(props, 'label', '')
  dayjs.locale(systemLng === 'es' ? 'es' : 'en')
  const { isMobile } = useMediaQuery()
  const { theme } = useTheme()
  const styles = themeStyles(theme)

  return (
    <ConfigProvider locale={systemLng === 'es' ? esES : enUS} theme={antdThemeConfig(theme)}>
      <Space direction="vertical" style={styles.datePickerContainer}>
        {_.isEmpty(label) ? null : <strong>{label}</strong>}
        <DatePicker
          style={styles.datePicker}
          format="MM/DD/YYYY"
          suffixIcon={<Icon style={styles.datePickerIcon} name="calendar alternate" />}
          allowClear={isMobile ? false : { clearIcon: <Icon style={styles.datePickerIcon} name="close" /> }}
          {...props}
        />
      </Space>
    </ConfigProvider>
  )
}

export default DateSelector
